module.exports = __webpack_public_path__ + "static/media/King of Mandol.6db9fe76.jpg";